import React from 'react'
import { Form } from 'react-bootstrap'

export default function CardDropAcoes({ modal, children, isConsumo = false }) {
  return (
    <Form ref={modal} className="menu-opcoes-container">
      <div
        className={`${isConsumo ? 'menu-opcoes-triangulo-dashboard-disposiivos-consumo' : 'menu-opcoes-triangulo'} campo-select-triangulo-cor-2`}
      />
      <div
        className={`${isConsumo ? 'menu-opcoes-corpo-dashboard-dispositivos-consumo' : 'menu-opcoes-corpo'} fundo-cor-3`}
      >
        <ul className="drop-acoes-lista-menu">{children}</ul>
      </div>
    </Form>
  )
}